import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreIncidents: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.incident-list.more-incidents',
		defaultMessage:
			'+ {incidentCount} more {incidentCount, plural, one {incident} other {incidents}}',
		description: 'Button to show more incidents',
	},
	lessIncidents: {
		id: 'servicedesk-object-active-incidents-panel.active-incident-panel.incident-list.less-incidents',
		defaultMessage: 'Show less',
		description: 'Button to show less incidents',
	},
});
